// TODO: Move utils to shared

export const MIN_PASSWORD_LENGTH = 8;
export const meetsLengthReq = pw => pw.length >= MIN_PASSWORD_LENGTH;

export const passesRegex = regex => pw => regex.test(pw);
export const hasLowerRegex = /(?=.*[a-z])/;
export const hasUpperRegex = /(?=.*[A-Z])/;
export const hasDigitRegex = /(?=.*\d)/;
export const checkHasLower = passesRegex(hasLowerRegex);
export const checkHasUpper = passesRegex(hasUpperRegex);
export const checkHasDigit = passesRegex(hasDigitRegex);

export const passesAllRequirements = pw =>
  checkHasLower(pw) &&
  checkHasUpper(pw) &&
  checkHasDigit(pw) &&
  meetsLengthReq(pw);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-password/utils/index.js